import { useParams } from "react-router-dom";
import * as api from "./invitationsApi";
import { CreateLocalInvitationUser } from "./models";

const useInvitationService = () => {
  const params = useParams() as { invitationId?: number };

  function getInvitationId() {
    return params.invitationId;
  }

  function getInvitationLoginMethods(invitationId: number, invitationToken: string) {
    return api.getInvitationLoginMethods(invitationId, invitationToken);
  }

  function createLocalUser(invitationId: number, invitationToken: string, data: CreateLocalInvitationUser) {
    return api.createLocalUser(invitationId, invitationToken, data);
  }

  return {
    getInvitationLoginMethods,
    createLocalUser,
    getInvitationId,
  };
};

export default useInvitationService;
